var _path, _rect, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 5.25512L17.245 4.89958C17.3085 5.05952 17.3235 5.20163 17.3289 5.28416C17.3334 5.35219 17.3333 5.42564 17.3333 5.47038C17.3333 5.4743 17.3333 5.478 17.3333 5.48145C17.3333 5.48753 17.3333 5.4937 17.3333 5.49995C17.3333 5.59542 17.3334 5.70949 17.3267 5.81047C17.3191 5.92659 17.2997 6.09383 17.2273 6.276L17.2273 6.27601C17.0748 6.65979 16.7709 6.96375 16.3871 7.11622M16.35 5.25512L16.3871 7.11622M16.35 5.25512L17.245 4.89958C17.1179 4.57975 16.8646 4.32646 16.5448 4.1994C16.3849 4.13586 16.2427 4.12087 16.1602 4.11544C16.0922 4.11097 16.0187 4.11104 15.974 4.11108C15.9701 4.11108 15.9664 4.11108 15.9629 4.11108H12.037C12.0335 4.11108 12.0298 4.11108 12.0259 4.11108C11.9812 4.11104 11.9077 4.11097 11.8397 4.11544C11.7572 4.12087 11.6151 4.13586 11.4551 4.1994C11.1353 4.32646 10.882 4.57975 10.7549 4.89958C10.6914 5.05952 10.6764 5.20163 10.671 5.28415C10.6665 5.35219 10.6666 5.42564 10.6666 5.47038C10.6666 5.4743 10.6666 5.478 10.6666 5.48145C10.6666 5.48753 10.6666 5.4937 10.6666 5.49995C10.6666 5.59541 10.6666 5.70949 10.6732 5.81047C10.6808 5.92659 10.7002 6.09383 10.7726 6.276C10.9251 6.65979 11.229 6.96375 11.6128 7.11622C11.795 7.18859 11.9622 7.20799 12.0784 7.21563C12.1793 7.22226 12.2934 7.22223 12.3889 7.2222C12.3951 7.2222 12.4013 7.2222 12.4074 7.2222H15.5926M16.35 5.25512L15.5926 7.2222M16.3871 7.11622C16.2049 7.18859 16.0377 7.20799 15.9216 7.21563M16.3871 7.11622L15.9216 7.21563M15.5926 7.2222C15.5986 7.2222 15.6048 7.2222 15.611 7.2222M15.5926 7.2222L15.611 7.2222M15.611 7.2222C15.7065 7.22223 15.8206 7.22226 15.9216 7.21563M15.611 7.2222L15.9216 7.21563",
    stroke: "#9F9F9F",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 14,
    height: 20,
    rx: 2,
    stroke: "#9F9F9F",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 20.6667,
    rx: 1.16667,
    ry: 1.11111,
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4e6f528e9cb333b6c1cbd097b1312e4d.svg";
export { ForwardRef as ReactComponent };